import { render, staticRenderFns } from "./InventoryBuyDetails.vue?vue&type=template&id=f9ff6cd4&scoped=true&"
import script from "./InventoryBuyDetails.vue?vue&type=script&lang=js&"
export * from "./InventoryBuyDetails.vue?vue&type=script&lang=js&"
import style0 from "./InventoryBuyDetails.vue?vue&type=style&index=0&id=f9ff6cd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ff6cd4",
  null
  
)

export default component.exports